// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/design-system/components/overlays/OverlayHeader.jsx

import React from "react";
import IconButton from "../actions/IconButton";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

function CloseIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M6 6l12 12M18 6L6 18"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function OverlayHeader({
  eyebrow,
  title,
  description,
  onClose,
  closeLabel = "Close",
  titleId,
  descriptionId,
  className = "",
}) {
  return (
    <header
      className={joinClassNames("oasys-overlay-header", className)}
    >
      <div className="oasys-overlay-header__content">
        {eyebrow ? (
          <span className="oasys-overlay-header__eyebrow">
            {eyebrow}
          </span>
        ) : null}

        <h2 id={titleId} className="oasys-overlay-header__title">
          {title}
        </h2>

        {description ? (
          <p
            id={descriptionId}
            className="oasys-overlay-header__description"
          >
            {description}
          </p>
        ) : null}
      </div>

      {onClose ? (
        <IconButton
          label={closeLabel}
          size="medium"
          variant="ghost"
          onClick={onClose}
          className="oasys-overlay-header__close"
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </header>
  );
}
